import { useQuery } from '@hooks/reactQuery';

import { getDropdownFilterApprovalUnits } from '@api/assignApprovalUnit';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithIdName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IApprovalUnit } from '@components/routes/AdminPanel/ManageApprovalUnits/interfaces';

import { refetchOptions } from '@constants/common';
import { FILTER_ASSIGN_APPROVAL_UNITS } from '@constants/queryKeys';

export const useQueryDropdownFilterApprovalUnits = () => {
	const {
		data: dropdownFilterApprovalUnits,
		isLoading: isLoadingDropdownFilterApprovalUnit,
		isFetching: isFetchingDropdownFilterApprovalUnit,
	} = useQuery<IApprovalUnit[], TSelectOption[]>({
		queryKey: [FILTER_ASSIGN_APPROVAL_UNITS],
		queryFn: extractQueryParams(getDropdownFilterApprovalUnits),
		select: (options) => {
			return optionsFormattedWithIdName(options);
		},
		...refetchOptions,
	});

	return {
		dropdownFilterApprovalUnits: dropdownFilterApprovalUnits || [],
		isLoadingDropdownFilterApprovalUnit: (
			isLoadingDropdownFilterApprovalUnit ||
			isFetchingDropdownFilterApprovalUnit
		),
	};
};
